import "./Registrierung.css";
import PropTypes from "prop-types";
import BisButton from "../components/bisButton/BisButton";

function Registrierung({onZurueckClick}) {
    return (
        <div className="registrierung-container">
            <p>Für die Registrierung im Bodenschutzkataster füllen Sie bitte das folgende Formular aus:</p>
            <a
                href="https://bisbokat.rlp-umwelt.de/bis-downloads/Antrag%20auf%20Zugangsdaten_2025.pdf"
                target="_blank"
                rel="noreferrer"
                aria-label="Antrag auf Zugangsdaten, öffnet als PDF in einem neuen Tab"
            >
                Antrag auf Zugangsdaten.pdf
            </a>
            <span className="hinweis">(wird in einem neuen Fenster geöffnet)</span>
            <br/>
            <p>Bitte senden Sie das ausgefüllte Formular unterschrieben an das Postfach<br/>
                <a href="mailto:bis-bokat@lfu.rlp.de"
                   aria-label="Support kontaktieren per E-Mail">bis-bokat@lfu.rlp.de</a>
            </p>
            <BisButton
                id="btn-zurueck-anmeldung"
                onClick={onZurueckClick}
                variant="solid"
                aria-label="Zurück zur Anmeldeseite"
                text="Zurück zur Anmeldung"
                className="registrierung-zurueck"
            />
        </div>
    );
}

Registrierung.propTypes = {
    onZurueckClick: PropTypes.func.isRequired,
};

export default Registrierung;
